export const ExtraInfoSelectorId = 'extraInfoSelector_id';
export const ExtraInfoFieldName = (id: number) => `extraInfoField_${id}`;
